import { useState } from 'react';
import { api } from '../../utils/api';
import { Button, Input, Card } from '../shared/UI';
import { useNavigate } from 'react-router-dom';

export function Setup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSetup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/api/auth/setup', { username, password });
      navigate('/login');
    } catch (err) {
      setError(err.error || 'Setup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <Card style={{ maxWidth: 400, width: '100%', padding: 40 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🚀</div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 24, color: 'var(--navy)' }}>System Setup</h1>
          <p style={{ color: 'var(--gray-500)', marginTop: 4 }}>Create the primary administrator account</p>
        </div>

        <form onSubmit={handleSetup} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Input label="Admin Username" value={username} onChange={setUsername} placeholder="e.g. admin" required />
          <Input label="Admin Password" type="password" value={password} onChange={setPassword} placeholder="••••••••" required />
          
          {error && <div style={{ padding: '12px 16px', background: 'var(--red-light)', color: 'var(--red)', borderRadius: 10, fontSize: 13, fontWeight: 500 }}>{error}</div>}
          
          <Button type="submit" size="lg" loading={loading} style={{ marginTop: 12 }}>Initialize System</Button>
        </form>
      </Card>
    </div>
  );
}
